import { DI } from '@aurelia/kernel';
export const IAuthOptions = DI.createInterface('IAuthOptions');
//# sourceMappingURL=configuration.js.map